import Box from "@mui/material/Box";
import BreadCrumb from "app/components/BreadCrumb";
import Loader from "app/components/Loader";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { useInjectReducer, useInjectSaga } from "utils/redux-injectors";

import { selectCustomerDetails } from "../../redux/selector";
import { customersActions, reducer, sliceKey } from "../../redux/slice";
import { customersSaga } from "../../redux/saga";
import CustomerDetailTabs from "./CustomerDetailTabs";
import CustomerDetailsForm from "./CustomerDetailsForm";
import { useStyles } from "./styles";

const CustomerDetails = () => {
  const { t, i18n } = useTranslation();
  const styles = useStyles();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();

  useInjectReducer({
    key: sliceKey,
    reducer,
  });

  useInjectSaga({
    key: sliceKey,
    saga: customersSaga,
  });

  const customerDetails = useSelector(selectCustomerDetails);

  useEffect(() => {
    if (!id) {
      return;
    }

    dispatch(customersActions.getCustomerDetails(id));

    return () => {
      dispatch(customersActions.clearCustomerDetails());
    };
  }, [dispatch, id]);

  return (
    <Box className={styles.container}>
      <Box className={styles.pageHeader} dir={i18n.dir()}>
        <BreadCrumb
          title={t("CUSTOMERS.TITLE")}
          subTitle={t("CUSTOMERS.DETAILS.TITLE")}
          onBackClick={() => navigate("/customers")}
        />
      </Box>

      <Box className={styles.scrollContent} dir={i18n.dir()}>
        <Box className={styles.pageContent}>
          {!customerDetails ? (
            <Loader loading />
          ) : (
            <Box className={styles.detailsSection}>
              <CustomerDetailsForm />
              <CustomerDetailTabs
                customerName={customerDetails.customerName}
                priceQuotes={customerDetails.priceQuotes || []}
                workOrders={customerDetails.workOrders || []}
                FinancialRows={customerDetails.Financial || []}
                documentRows={customerDetails.documents || []}
                timelineRows={customerDetails.timeline || []}
              />
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default CustomerDetails;
